declare global {
  interface Window {
    // Eslint disabled - we just need to check if Cypress is defined
    // eslint-disable-next-line -eslint/no-explicit-any
    Cypress?: any;
  }
}

// Safe check for both Node.js and browser environments
export const isRunningInCypress = (): boolean => {
  // Check if we're in a browser environment with window
  if (typeof window !== 'undefined' && window?.Cypress) {
    return true;
  }

  // Check if we're in a Node.js environment with Cypress global
  // @ts-ignore - Just a check to be sure, we don't need to use/type it
  if (typeof Cypress !== 'undefined') {
    return true;
  }

  return false;
};
